import _ from 'lodash'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { FormValueSelector } from '../../../Common/forms'
import ProposalStatusBar from './ProposalStatusBar'
import withSupplierSharedLink from '../../../Common/HOC/withSupplierSharedLink'
import HeadingWithId from '../HeadingWithId/HeadingWithId'
import { PROPOSAL_TYPE_NAME } from '../../../../constants/proposalTypes'
import { HyperLink } from '../../../Common/Form'
import { PROPOSAL_PHASE_TYPE, PROPOSAL_TYPE } from '@vzmi/shp_shared_compo/constants/proposal'
import { fetchBatchProposal } from '../../../../actions'
import useBatchProposalById from './useBatchProposalById'
import { Toast } from '@vzmi/shp_shared_compo'

const withStatusBarValues = WrappedCompo => props => {
  const statusBarSelector = select => ({
    proposalId: select('id'),
    listing: select('listing'),
    suggestion: select('suggestion'),
    reviewStatus: select('reviewStatus'),
    executeStatus: select('executeStatus'),
    executeResult: select('executeResult'),
    declineReason: select('declineReason'),
    declineDetail: select('declineDetail'),
    executedTs: select('executedTs'),
    modifiedTs: select('modifiedTs'),
    parent: select('parent'),
    batch: select('batch')
  })

  return (
    <FormValueSelector selector={statusBarSelector}>
      {
        values => {
          const totalProps = {
            ...props,
            statusBarValues: values
          }
          return <WrappedCompo {...totalProps} />
        }
      }
    </FormValueSelector>
  )
}

const onBatchProposalByIdError = message => Toast.error(`批次提案錯誤：${message}`)

const ProposalStatusBarBlock = props => {
  const {
    sharedLink,
    proposalType,
    statusBarValues,
    actions
  } = props
  let parentId
  let parentIdSuffix = ''
  let parentProposalType
  let parentProposalTypeText
  const headingTitle = `提案內容檢視-${PROPOSAL_TYPE_NAME[proposalType]}`
  const proposalId = _.get(statusBarValues, 'proposalId')

  const hasParent = !_.isEmpty(_.get(statusBarValues, 'parent', {})) // 若有parent => parent:{id: 683158, type: "updateListing"}，若無=>parent:undefined

  if (hasParent) { // 取得parent 欄位資料
    parentId = _.get(statusBarValues, 'parent.id', '')
    parentProposalType = _.get(statusBarValues, 'parent.type', '')
    parentProposalTypeText = PROPOSAL_TYPE_NAME[parentProposalType]
  }

  const batch = _.get(statusBarValues, 'batch', {})
  const hasBatch = !_.isEmpty(batch)
  if (hasBatch) {
    const {
      id: batchId,
      type: batchType
    } = batch
    parentId = batchId
    parentIdSuffix = `&type=${batchType}`
    parentProposalType = `../batchUpload/${PROPOSAL_TYPE.UPDATE_IMAGE}`
    parentProposalTypeText = '批次上傳賣場圖片'
  }

  const headingSubTitle = proposalId ? `提案編號：${proposalId}` : ''

  const buyGdSaleUrl = _.get(sharedLink, 'buyGdSale')

  const batchProposalResult = useBatchProposalById(
    actions.fetchBatchProposal,
    batch,
    hasBatch,
    onBatchProposalByIdError
  )

  return (
    <>
      <HeadingWithId
        title={headingTitle}
        subtitle={(
          (hasParent || hasBatch)
            ? (
              <>
                {`${headingSubTitle} (來自${parentProposalTypeText}提案 `}
                <HyperLink
                  target='_blank'
                  href={`../${parentProposalType}/${PROPOSAL_PHASE_TYPE.OVERVIEW}?id=${parentId}${parentIdSuffix}`}
                >
                  {parentId}
                </HyperLink>
                )
              </>
            )
            : headingSubTitle)}
      />
      <ProposalStatusBar
        proposalType={proposalType}
        buyGdSaleUrl={buyGdSaleUrl}
        hasBatch={hasBatch}
        batchProposalResult={batchProposalResult}
        {...statusBarValues}
      />
    </>
  )
}

const withActions = Comp => connect(
  () => ({}),
  dispatch => {
    const actions = {
      fetchBatchProposal
    }
    return {
      actions: bindActionCreators(actions, dispatch)
    }
  }
)(Comp)

const hoc = _.flow(
  withActions,
  withStatusBarValues,
  withSupplierSharedLink
)

export default hoc(ProposalStatusBarBlock)
